<template>
    <div>
        <div class="poster-wrapper">
            <img
                v-if="!isPosterLoading"
                class="poster-img"
                :src="
                    poster ||
                        'https://highered.global/wp-content/uploads/2018/11/topabout.jpg'
                "
            />
        </div>
        <Paper class="overlay-poster-img" :header="header">
            <div class="p-5 pb-7">
                <div v-if="!isLoading" v-html="description" />
                <PresentationSkeleton v-else />
            </div>
        </Paper>
    </div>
</template>

<script>
import PresentationSkeleton from '~/components/skeletons/PresentationSkeleton';

export default {
    name: 'Presentation',
    components: { PresentationSkeleton },
    props: {
        description: String,
        poster: String,
        companyName: {
            type: String,
            optional: true,
        },
        companyCatchPhrase: {
            type: String,
            optional: true,
        },
        isLoading: Boolean,
        isPosterLoading: Boolean,
    },
    computed: {
        header() {
            if (this.companyName) {
                if (this.companyCatchPhrase) {
                    return `${this.companyName} - ${this.companyCatchPhrase}`;
                } else {
                    return this.companyName;
                }
            }
            return undefined;
        },
    },
};
</script>

<style scoped>
.poster-wrapper {
    z-index: -5;
    width: 100%;
    height: 170px;
    max-height: 170px;
    background-color: rgb(218, 218, 218);
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
}

.poster-img {
    width: 100%;
    height: 170px;
    max-height: 170px;
    object-fit: cover;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
}
.overlay-poster-img {
    position: relative;
    top: calc(-1 * var(--border-radius));
    margin-bottom: calc(-1 * var(--border-radius));
}
</style>
